import { colors } from '@alixpartners/ui-components';
import styled from 'styled-components';

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	height: 100vh;
`;

export const InnerContainer = styled.div`
	display: flex;
	justify-content: space-evenly;
`;

export const FilterContainer = styled.div`
	flex: 0.2;
	margin-top: 50px;
	margin-left: 30px;
`;

export const Filters = styled.div`
	display: flex;
`;

export const FilterLabel = styled.span`
	color: #a4a4a6;
`;

export const BaselineSummary = styled.div`
	flex: 0.4;
	margin-top: 50px;
`;

export const SummaryTitle = styled.span`
	display: flex;
	font-size: 13px;
	font-weight: bold;
	color: ${colors.grey400};
	text-transform: uppercase;
	.ap-icon {
		margin-left: 5px;
	}
`;

export const Status = styled.div`
	flex: 0.4;
	margin-top: 0px;
	color: ${props => props.Fcolor};
`;

export const StatusTitle = styled.span`
	font-weight: bold;
`;

export const ColumnContainer = styled.div`
	display: flex;
	flex-direction: column;
	margin: 10px 20px 20px 20px;
`;

export const Header = styled.div`
	width: 100%;
	background-color: white;
	color: black;
	display: flex;
	justify-content: flex-end;
	font-size: 12px;
`;

export const HeaderSpan = styled.span`
	display: flex;
	justify-content: center;
	align-items: center;
	padding-left: 10px;
`;

export const RefreshSpan = styled.span`
	background-color: white;
	color: ${colors.red500};
	padding: 2px;
`;
export const KpiSqaureGridContainer = styled.div`
	display: grid;
	padding: 10px;
	grid-template-columns: repeat(${props => props.columns || 4}, 1fr);
	grid-template-rows: repeat(${props => props.rows || 1}, 1fr);
	height: ${props => props.height || '100%'};
	gap: 10px;
`;

export const StackFilterWrapper = styled.div`
	padding: 5px 0 0 8px;
  	> div {
		> div>div {
        border-radius: 0;
		}
  .ap-button-main {
    height: 32px;
  }
`;

export const SingleFilterWrapper = styled.div``;
export const MultiSelectWrapper = styled.div`
	> div > div {
		border-radius: 0;
	}
	margin: 5px 0px 0px 0;
`;

export const SectionFormLabel = styled.div`
	flex: 0 0 100%;
	font-size: 10px;
	font-style: normal;
	font-weight: 400;
	line-height: 19px;
	letter-spacing: 0.3px;
	text-align: left;
	color: ${colors.grey5};
	margin-bottom: 4px;
`;

export const IconWrapper = styled.span`
	display: flex;
	align-items: center;
	justify-content: flex-end;
`;

export const TableFilterHeader = styled.div`
	width: 100%;
	background-color: white;
	color: black;
	display: flex;
	justify-content: space-between;
	font-weight: bold;
	font-size: 13px;
	font-family: Roboto;
	border: ${colors.grey300};
	padding: 3px;
	border: 1px solid ${colors.grey300};
	border-bottom: none;
`;

export const GridContainer = styled.div`
	display: grid;
	grid-template-columns: repeat(3, minmax(180px, 1fr));
	font-size: 12px;
	padding: 1% 1% 1% 1.3%;
`;

export const GridItem = styled.div`
	background-color: ${props => (props.selected ? colors.green500 : 'white')};
	color: ${props => (props.selected ? 'white' : colors.grey600)};
	font-weight: bold;
	display: flex;
	justify-content: center;
	align-items: center;
	cursor: pointer;
	border: 1px solid #ddd;
	height: 28px;
	padding: 1px;
	transition: background-color 0.3s ease;
`;
